export const imageConstants = {
    UPLOAD_REQUEST: 'IMAGES_UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'IMAGES_UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'IMAGES_UPLOAD_FAILURE',
    GETALL_REQUEST: 'IMAGES_GETALL_REQUEST',
    GETALL_SUCCESS: 'IMAGES_GETALL_SUCCESS',
    GETALL_FAILURE: 'IMAGES_GETALL_FAILURE'
  };
